// Shared styles for all timeline card types.
// Each card variant (text, image, url, etc.) imports these for a consistent
// outer shell and can add type-specific styles internally.

export const cardSx = {
    background: "linear-gradient(135deg, rgba(9,25,32,0.85) 0%, rgba(20,40,55,0.7) 100%)",
    border: "1px solid #3F464F",
    borderRadius: "12px",
    padding: "12px 16px",
    maxWidth: 450,
    width: "100%",
};

export const timeLabelSx = {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#02cfee",
    letterSpacing: 0.3,
    textAlign: "left" as const,
};

export const titleSx = {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#F2F5FA",
    textAlign: "left" as const,
};

export const detailsSx = {
    fontSize: "0.8rem",
    fontWeight: 300,
    color: "rgba(242, 245, 250, 0.75)",
    lineHeight: 1.6,
    textAlign: "left" as const,
};

export const iconSx = {
    width: 22,
    height: 22,
    opacity: 0.7,
    mt: "2px",
    flexShrink: 0,
};
